import { ApiClientError } from "@/services/http/client";
import { queueMutation, type QueueMutationInput } from "@/offline/outbox";

export type OfflineMutationResult<T> = { mode: "SYNCED"; value: T } | { mode: "QUEUED"; entityId: string };

export const executeOrQueue = async <T, P>({ offline, request, execute }: { offline: boolean; request: QueueMutationInput<P>; execute: () => Promise<T> }): Promise<OfflineMutationResult<T>> => {
  if (offline) {
    const queued = await queueMutation(request);
    return { mode: "QUEUED", entityId: queued.draft.entityId };
  }
  try {
    return { mode: "SYNCED", value: await execute() };
  } catch (reason) {
    if (reason instanceof ApiClientError && reason.status === 0) {
      const queued = await queueMutation(request);
      return { mode: "QUEUED", entityId: queued.draft.entityId };
    }
    throw reason;
  }
};
